export default class VisibilityHelper {
    /**
     * Determine if an element is taking up space on the page.
     * Still truthy if opacity is less than 1.
     * https://davidwalsh.name/offsetheight-visibility
     *
     * @param {element} - Node
     * @returns {Boolean}
     */
    static isVisible(element) {
        return element.offsetHeight > 0;
    }

    /**
     * Determine if an element is taking up space on the page and visible in the
     * viewport, even partially.
     *
     * @param {element} - Node
     * @returns {Boolean}
     */
    static isVisibleInViewport(element) {
        return element.offsetHeight > 0 && VisibilityHelper.isInViewportPartially(element);
    }

    /**
     * Determine will relative certainty if an element is entirely in the
     * viewport.
     * https://gist.github.com/davidtheclark/5515733#file-iselementinviewport-js
     *
     * @param {element} - Node
     * @returns {Boolean}
     */
    static isInViewportFully(element) {
        const rect = element.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /**
     * Determine with relative certainty if any portion of an element is in the
     * viewport.
     * https://gist.github.com/davidtheclark/5515733#gistcomment-2113205
     *
     * @param {element} - Node
     * @returns {Boolean}
     */
    static isInViewportPartially(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;

        const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
        const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

        return vertInView && horInView;
    }
}
